import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-material-and-process-list',
  templateUrl: './material-and-process-list.component.html',
  styleUrls: ['./material-and-process-list.component.css']
})
export class MaterialAndProcessListComponent  implements AfterViewInit {
  displayedColumns: string[] = ['srNo', 'typeOfRoad', 'constructionSteps', 'materialsNeeded', 'machinesEquipment'];
  materials = [
    { srNo: 1, typeOfRoad: 'Highway', constructionSteps: 'Step 1', materialsNeeded: 'Cement', machinesEquipment: 'Excavator', status: 'pending' },
    { srNo: 2, typeOfRoad: 'Street', constructionSteps: 'Step 2', materialsNeeded: 'Sand', machinesEquipment: 'Truck', status: 'Verified' },
  ];
  dataSource = new MatTableDataSource(this.materials);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  onStatusChange(event: any) {
    // const status = event.value;
    const status = (event.target as HTMLSelectElement).value;

    this.dataSource.data = status
      ? this.materials.filter(material => material.status === status)
      : this.materials;
  }
}
 